<template>
  <section
    class="container h-full max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 pt-5 md:pt-10 lg:pt-12 min-h-screen">
    <Titre textePrincipal="Chats femelles 1 an et + disponibles pour " texteAccentue="adoption"
      :isSidebarOpen="isSidebarOpen" />
    <p class="mb-12 w-full"></p>

    <div class="max-w-full flex flex-wrap flex-row justify-center items-stretch gap-6 mb-20">

      <Card
        v-for="(card, index) in cards"
        :key="index"
        :title="card.title"
        :details="card.details"
        :reserved="card.reserved"
        :isMale="false"
        :infoAdditionnel="card.infoAdditionnel"
        :imageSrc="card.imageSrc"
        :altText="card.altText"
        :imageTitle="card.imageTitle"
        :chatFemelleAdoptee="card.chatFemelleAdoptee || false"
        >
        <!-- Choix automatique du bouton selon sexe -->
        <BoutonRose />

      </Card>
      <div v-if="cards.length === 0" class="text-center text-gray-500">Aucun chat femelle de 1 an et plus à afficher.</div>
    </div>

    <div class="container flex flex-wrap flex-row justify-center items-stretch gap-6 mb-10">
      <router-link to="/chatons-6-12-mois" class="px-4 py-2 text-white bg-navigation hover:bg-primaire rounded-md" aria-label="Voir les chatons de 6 à 12 mois" title="Voir les chatons de 6 à 12 mois">
        ◄ Chatons (6-12 mois)
      </router-link>
      <router-link to="/chats-males" class="px-4 py-2 text-white bg-navigation hover:bg-primaire rounded-md" title="Voir les chats mâles de 1 an et plus">
        Chats males 1 an et + ►
      </router-link>
    </div>

    <div class="container flex justify-center items-center flex-col mb-10">
      <p class="text-center text-2xl text-gray-700 mb-4">Vous avez un coup de coeur ?</p>
      <span class="ml-2">
        <a href="mailto:info@animauxdelasecondechance.com?subject=Adoption d'un chat femelle !&body=Bonjour, j'aimerais adopter un de vos chats femelles qui est âgée de 1 an et plus. Message :"
          target="_blank" title="Écrivez-nous !" rel="noopener noreferrer"
          class="inline-flex items-center px-3 py-2 mt-5 text-sm sm:text-md md:text-lg font-medium text-center text-white bg-action rounded-lg hover:bg-navigation focus:ring-4 focus:outline-none focus:ring-white dark:primaire dark:hover:bg-navigation dark:focus:ring-white">
          Contactez-nous !
        </a>
      </span>
    </div>

  </section>

</template>

<script setup>
import Titre from '../composants/Titre.vue';
import Card from '../composants/Card.vue';
import BoutonRose from '../composants/BoutonRose.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import { useListeChatsFemelles } from '../composables/apiListeChats.js';
import { computed, onMounted } from 'vue';

const { listeChatsFemelles, chargerListeChatsFemelles } = useListeChatsFemelles();


onMounted(() => {
  chargerListeChatsFemelles();
});

const cards = computed(() => {
  const chatsArray = Array.isArray(listeChatsFemelles.value)
    ? listeChatsFemelles.value
    : Object.values(listeChatsFemelles.value || {});

    // Ajoute ce log pour voir les valeurs de date_adoption
  console.log('Chats reçus:', chatsArray.map(c => ({ nom: c.nom, date_adoption: c.date_adoption })));


  return chatsArray
    .filter(chat => !chat.date_adoption || chat.date_adoption === null || chat.date_adoption === undefined || chat.date_adoption.trim() === '')
    .sort((a, b) => {
      const noA = Number(a.no_identification || 0);
      const noB = Number(b.no_identification || 0);
      return noB - noA;
    })

    .map(chat => {
      // Vérifié si le chat est réservé
      const sterilisation = (chat.sterilisation && chat.sterilisation.toLowerCase() === 'oui')
        ? 'Stérilisée'
        : null;

      const vaccinVermifugeList = [];
      if (chat.vaccin && chat.vaccin.toLowerCase() === 'oui') {
        vaccinVermifugeList.push('vaccinée');
      }
      if (chat.vermifuge && chat.vermifuge.toLowerCase() === 'oui') {
        vaccinVermifugeList.push('vermifugée');
      }

      function joinWithEt(arr) {
        if (arr.length === 0) return '';
        if (arr.length === 1) return arr[0];
        return arr.slice(0, -1).join(', ') + ' et ' + arr[arr.length - 1];
      }

      const vaccinVermifuge = joinWithEt(vaccinVermifugeList);

      let sterilisationVaccinVermifuge = '';
      if (sterilisation && vaccinVermifuge) {
        sterilisationVaccinVermifuge = `${sterilisation}, ${vaccinVermifuge}`;
      } else if (sterilisation) {
        sterilisationVaccinVermifuge = sterilisation;
      } else if (vaccinVermifuge) {
        sterilisationVaccinVermifuge = vaccinVermifuge;
      }

      return {
        ...chat,
        title: `${chat.nom}\u00A0\u00A0#${chat.no_identification || 'N/A'}`,
        no_identification: chat.no_identification,
        reserved: chat.reserve === 1 || chat.reserve === "oui" || chat.reserve === '1'
        ? "oui"
        : "non",
        details: [
          chat.type
            ? `${chat.type} née ${chat.date_de_naissance || 'N/A'}`
            : '',
          sterilisationVaccinVermifuge,
        ].filter(Boolean),
        imageSrc: chat.image,
        altText: chat.nom,
        imageTitle: chat.nom,
        infoAdditionnel: chat.info_additionnelle || chat.infoAdditionnel || '',
      };

    });

});

</script>

<style scoped></style>